import { Flex, FormControl, FormControlProps, Text } from '@chakra-ui/react';
import { FC } from 'react';
import { Control, useController } from 'react-hook-form';
import { FormValues } from '../../types';
import RadioCard from './RadioCard';

interface Props extends FormControlProps {
  name: keyof FormValues;
  control: Control<FormValues, any>;
  options: Array<{ label: string; value: any }>;
  defaultValue: any;
}

const RadioGroupRHF: FC<Props> = ({
  name,
  control,
  options,
  defaultValue,
  ...formControlProps
}) => {
  const { field } = useController({
    name,
    control,
    defaultValue,
  });

  if (options.length < 2) {
    return null;
  }

  return (
    <FormControl w="full" {...formControlProps}>
      <Flex w="full">
        {options.map(({ label, value }) => (
          <RadioCard
            key={value}
            isChecked={field.value == value}
            onClick={() => field.onChange(value)}
          >
            <Text>{label}</Text>
          </RadioCard>
        ))}
      </Flex>
    </FormControl>
  );
};

export default RadioGroupRHF;
